import { getDefaultValueType, transformProps, } from "motion-dom";
import { createBox } from "../../projection/geometry/models";
import { DOMVisualElement } from "../dom/DOMVisualElement";
import { camelToDash } from "../dom/utils/camel-to-dash";
import { buildSVGAttrs } from "./utils/build-attrs";
import { camelCaseAttributes } from "./utils/camel-case-attrs";
import { isSVGTag } from "./utils/is-svg-tag";
import { renderSVG } from "./utils/render";
import { scrapeMotionValuesFromProps } from "./utils/scrape-motion-values";
export class SVGVisualElement extends DOMVisualElement {
    constructor() {
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
        this.measureInstanceViewportBox = createBox;
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if (transformProps.has(key)) {
            const defaultType = getDefaultValueType(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !camelCaseAttributes.has(key) ? camelToDash(key) : key;
        return instance.getAttribute(key);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return scrapeMotionValuesFromProps(props, prevProps, visualElement);
    }
    build(renderState, latestValues, props) {
        buildSVGAttrs(renderState, latestValues, this.isSVGTag, props.transformTemplate, props.style);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        renderSVG(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = isSVGTag(instance.tagName);
        super.mount(instance);
    }
}
//# sourceMappingURL=SVGVisualElement.js.map